import useArtistEventChatPageElement from '../../../hooks/artistChats/useArtistEventChatPageElement';

const ArtistEventChatPage = () => useArtistEventChatPageElement();

export default ArtistEventChatPage;
